export type PagedSyncResult = {
  syncedThrough: number;
  hasMore?: boolean;
};

export async function finalizePagedSync(
  result: PagedSyncResult,
  handlers: {
    acknowledge: (syncedThrough: number) => Promise<void>;
    continueFrom?: (syncedThrough: number) => Promise<void>;
  }
): Promise<void> {
  await handlers.acknowledge(result.syncedThrough);
  if (result.hasMore && handlers.continueFrom) {
    await handlers.continueFrom(result.syncedThrough);
  }
}

export async function drainPaged<TPage extends PagedSyncResult>(
  fetchPage: (cursor: number) => Promise<TPage>,
  options: {
    initialCursor?: number;
    processPage: (page: TPage) => Promise<void>;
  }
): Promise<TPage | null> {
  let cursor = options.initialCursor ?? 0;
  let lastPage: TPage | null = null;

  while (true) {
    const page = await fetchPage(cursor);
    lastPage = page;
    await options.processPage(page);

    if (!page.hasMore) {
      return lastPage;
    }

    if (!Number.isFinite(page.syncedThrough) || page.syncedThrough <= cursor) {
      return lastPage;
    }

    cursor = page.syncedThrough;
  }
}
